import { useQueryClient } from '@tanstack/vue-query';
import { getCurrentInstance } from 'vue';
import * as Sentry from '@sentry/vue';
import { tokenKey, roleKey } from '~/constants/auth';

const useSuccessfulLogout = () => {
  const authStore = useAuthStore();
  // `useQueryClient` taps into Vue's injection context, which is only
  // available inside `setup()`. When called from a TanStack mutation's
  // `onError` (already outside setup) it throws and the original error is
  // swallowed. Skip cache invalidation gracefully in that case.
  const queryClient = getCurrentInstance() ? useQueryClient() : null;
  const token = useStatefulCookie(tokenKey);
  const role = useStatefulCookie(roleKey);
  const { cleanPopup } = useUIStore();
  const logout = async (redirectPath?: string) => {
    cleanPopup();
    queryClient?.clear();

    token.value = undefined;
    role.value = undefined;

    Sentry.setUser(null);

    document.dispatchEvent(
      new CustomEvent('auth:logout', {
        detail: {
          leadId: authStore.getUser?.leadId,
        },
      }),
    );

    await nextTick();

    authStore.logout();
    return navigateTo(redirectPath ? redirectPath : '/login');
  };

  return {
    logout,
  };
};

export default useSuccessfulLogout;
